import { render, staticRenderFns } from "./pc-checkbox-native.vue?vue&type=template&id=81916a1e&scoped=true&"
import script from "./pc-checkbox-native.vue?vue&type=script&lang=js&"
export * from "./pc-checkbox-native.vue?vue&type=script&lang=js&"
import style0 from "./pc-checkbox-native.vue?vue&type=style&index=0&id=81916a1e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81916a1e",
  null
  
)

export default component.exports